import Api from "./api";
export async function handleResendPaymentToken(id) {
    console.log("Resending payment token for enrollmentId:", id);
    try { 
      const res = await Api.post(
        `learner-enrollments/${id}/resend-payment-token`,
      );
      if (res && res.paymentLink) {
        setTimeout(() => {
          window.location.href = res.paymentLink;
        }, 1500);
      }
    } catch (err) {
      throw new Error(err.message || "Failed to resend payment token");
    }
  } 